// extracted by mini-css-extract-plugin
module.exports = {"torrent":"ProtocolLabel-torrent-3aqvR Label-label-30Bqv","usenet":"ProtocolLabel-usenet-3qKV1 Label-label-30Bqv"};